/**
 * Import jQuery
 */
import jQuery from "jquery";
window.$ = window.jQuery = jQuery;


/**
 * Import Bootstrap
 */
import 'bootstrap';


/**
 * Import Template
 */
import './navigation';
import './hamburger';
import './search';
import './fancybox';
import './swiper';
import './masonry';
import './template';
import './scripts';
